import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import installShared from '~src/shared';
import ElementPlus from 'element-plus';

const app = createApp(App);

app.use(router);
app.use(ElementPlus);

// delay mount so we can load configuration
setTimeout(() => {
    installShared(app, 'boostsite_ai_config_admin');
    app.mount('#vue-admin-app');
}, 200);
